import React, { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffectFn } from '@ngneat/effects-hooks';
import { useObservable } from '@ngneat/react-rxjs';
import { documentsQuery, documentsService, searchDocumentsEffect } from '@store/documents';
import TabsComponent from '@components/tabs/Tabs.component';
import { DocumentsStatus } from './DocumentStatus.enum';
import AdminDocument from './adminDocuments/AdminDocument.screen';
import ExecutionDocument from './executionDocuments/ExecutionDocument.screen';
import IssueDocument from './IssueDocument.screen.tsx/IssueDocument.screen';

const DocumentViews = {
  ADMIN: <AdminDocument />,
  EXECUTION: <ExecutionDocument />,
  ISSUE: <IssueDocument />,
};

const DocumentsScreen = () => {
  const { t } = useTranslation();

  const searchDocuments = useEffectFn(searchDocumentsEffect);
  const [filters] = useObservable(documentsQuery.filters$);
  const [sortModel] = useObservable(documentsQuery.sort$);
  const [tablePagination] = useObservable(documentsQuery.pagination$);

  useEffect(() => {
    searchDocuments({ filters, tablePagination, sort: sortModel });
  }, [filters, searchDocuments, sortModel, tablePagination]);

  const CurrentDocumentView: JSX.Element = DocumentViews[filters.documentKind as unknown as DocumentsStatus ?? 'ADMIN'];

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={2}>
      <Typography fontSize="30px" fontWeight="700">
        {t('documents.title')}
      </Typography>
      <TabsComponent
        ariaLabel="secondary"
        handleChange={(value) => {
          documentsService.setFilters('documentKind')(DocumentsStatus.tabs[value]);
        }}
        value={DocumentsStatus.tabs.indexOf(filters.documentKind as unknown as DocumentsStatus ?? undefined)}
        tabs={[t('routes.adminDocuments'), t('routes.executions'), t('routes.noncompliance')]} />
      {CurrentDocumentView}
    </Stack >
  );
};

export default DocumentsScreen;